import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from './auth.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router,private authService: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log("tesdasads");
        if (req.headers.get('No-Auth') == "True"){
            return next.handle(req.clone());
           //return;
        }
            

        console.log(localStorage.getItem('userToken'));
        if (localStorage.getItem('userToken') != null) {
            console.log(localStorage.getItem('userToken'));
            const clonedreq = req.clone({
                headers: req.headers.set("Authorization", "Bearer " + localStorage.getItem('userToken'))
            });
            return next.handle(clonedreq)
                .pipe(tap(
                    succ => { console.log("setroles"); this.authService.setNavigationRoles();},
                    err => {
                        console.log(err.status);
                        if (err.status === 401){
                            this.router.navigateByUrl('/login');
                        } else if (err.status === 403){
                        this.router.navigateByUrl('/forbidden');
                        }
                    }
                ));
        }
        else {
            console.log("WTFFFF");
            this.router.navigateByUrl('/login');
        }
    }
}